import CustomizeBundleForSHP2 from '@elem/compPage/CustomizeBundleForSHP2';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';

export default function Page({ SEO }: any) {
    const { useLang, useEffect, useRouter, useState } = useGlobal();
    const [theme, setTheme] = useState('black');
    const { t } = useLang('customize_bundle_for_shp2');
    const router = useRouter();
    const { locale } = router;

    useEffect(() => {
        if (!['us'].includes(locale)) {
            return router.push('/404');
        }
    }, []);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['us']} locale={locale} pathname={'customize-bundle-for-shp2'} />
            <PageLayout hideToTop className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <CustomizeBundleForSHP2 />
            </PageLayout>
            <style global jsx>
                {`
                    .ef-top-offers {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}
